import React from "react";
import className from "~/kernel/styling/className";

export type LabelProps = {
  label: string | React.ReactElement | undefined;
  id: string;
  required?: boolean;
  disabled?: boolean;
};

export default function Label({ id, label, required, disabled }: LabelProps) {
  const labelClassName = className("block w-full", {
    "text-slate-400": disabled,
  });

  if (typeof label === "undefined") {
    return null;
  }

  if (typeof label !== "string") {
    return label;
  }

  if (required) {
    return (
      <label htmlFor={id} className={labelClassName}>
        {label} <span className="text-error">*</span>
      </label>
    );
  }

  return (
    <label htmlFor={id} className={labelClassName}>
      {label}
    </label>
  );
}
